import { Moment } from 'moment'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LineArrowRightIcon from 'components/Luxkit/Icons/line/LineArrowRightIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { TripItem } from 'tripPlanner/types/tripItem'

const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${(props) => props.theme.font.primary.weight.regular};
  font-size: ${rem(14)};
  line-height: ${rem(24)};
`

const DateTimeDisplay = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(20)};
  width: 100%;
`

const Mid = styled.div`
  display: flex;
  align-items: center;
`

type SectionTitleProps = {
  text: string
}
function SectionTitle(props: SectionTitleProps) {
  return <BodyText variant="medium" weight="semi-bold">
    {props.text}
  </BodyText>
}

type DateTimeBlockProps = {
  title: string
  date?: Moment
  time?: Moment
  day?: number
}
function DateTimeBlock({ title, date, time, day }: DateTimeBlockProps) {
  const timeFormat = useRegionTimeFormat()

  if (!date && !time && !day) return null

  return (
    <DateTime>
      <SectionTitle text={title} />
      {day && <BodyText variant="large">Day {day}</BodyText>}
      {!day && date && (
        <BodyText variant="large">
          {date?.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
        </BodyText>
      )}
      {time && <BodyText variant="large">{time?.format(timeFormat)}</BodyText>}
    </DateTime>
  )
}

type Props = {
  startTitle: string
  endTitle: string
  item: TripItem
}
function StartAndEndDateTime({ startTitle, endTitle, item }: Props) {
  const { startDate, startTime, startDay, endDay } = item
  const endDate = 'endDate' in item ? item.endDate : undefined
  const endTime = 'endTime' in item ? item.endTime : undefined
  const haveBothStartAndEndDate = (startDate && endDate) || (startDay && endDay)
  if (haveBothStartAndEndDate) {
    return (
      <DateTimeDisplay>
        <DateTimeBlock
          title={startTitle}
          date={startDate}
          time={startTime}
          day={startDay}
        />
        <Mid>
          <LineArrowRightIcon colour="neutral-two" />
        </Mid>
        <DateTimeBlock
          title={endTitle}
          date={endDate}
          time={endTime}
          day={endDay}
        />
      </DateTimeDisplay>
    )
  }

  return (
    <>
      <DateTimeBlock
        title={startTitle}
        date={startDate}
        time={startTime}
        day={startDay}
      />
      <DateTimeBlock
        title={endTitle}
        date={endDate}
        time={endTime}
        day={endDay}
      />
    </>
  )
}
export default StartAndEndDateTime
